import React from "react";

import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";
import { Icon } from "@abb/abb-common-ux-react";
import { ABB_CARET_UP, ABB_CARET_DOWN } from "../../utilities/IconConstants";

interface ISummary {
  isShow?: boolean;
  isToggle?: boolean;
  onToggleShow?: () => void;
}

export default class Summary extends React.Component<ISummary> {
  public render() {
    return (
      <Translation>
        {
          t =>
            <div className="summary pb-2">
              <div className="summary-text" onClick={this.props.onToggleShow}>
                {this.props.isToggle ? this.props.isShow ? (
                  <Icon className="mr-3" name={ABB_CARET_DOWN} />
                ) : (
                    <Icon className="mr-3" name={ABB_CARET_UP} />
                  ) : null}
                {t(CONSTANTS.LABEL_SUMMARY)}</div>
              <div className="header-underline"></div>
              {this.props.isShow ? null:this.props.children}
            </div>
        }
      </Translation>
    );
  }
}
